import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';

const useClinicGroup = () => {
  const { data, error, mutate } = useSWR(
    '/clinics/admin/clinic-groups',
    async (url) => {
      const response = await axiosInstance.get(url);

      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useClinicGroup;
